import { render, staticRenderFns } from "./ComissaoForm.vue?vue&type=template&id=454ab63e"
import script from "./ComissaoForm.vue?vue&type=script&lang=js"
export * from "./ComissaoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports